// extracted by mini-css-extract-plugin
module.exports = {"messageText":"bpC6","card":"zxhI"};